import React, { FC } from 'react';
import { TwoLineList } from '../two_line_list/TwoLineList';
import { ProtectedImageThumbnails } from '../protected_image_thumbnails/ProtectedImageThumbnails';
import { connect } from 'react-redux';
import { TroubleshootingAnswerDisplay } from '../work_orders_detail_details_page/EachTroubleshootingGroupDisplay';
import { extractTextContent, nullSafeGet } from '../../utils/DataAccessUtils';

const WorkOrderSummary: FC<any> = ({
	workOrderDetails,
	photoStrings,

	userType,
}): React.ReactElement => {
	return (
		<>
			<TwoLineList
				listItems={workOrderDetails.filter((field) => !!field.value)}
				lineOneRender={(record) => (
					<TroubleshootingAnswerDisplay
						title={extractTextContent(record.key)}
						answer={record.value}
						userType={userType}
					/>
				)}
				lineTwoRender={(record) => extractTextContent(record.key)}
			/>
			<ProtectedImageThumbnails
				style={{ marginTop: 16 }}
				imageWidth={64}
				imageHeight={64}
				photoStrings={photoStrings}
				role={userType}
			/>
		</>
	);
};

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(WorkOrderSummary);
